/*
 * @Author: Cao_ming
 * @Date: 2020-10-10 17:27:29
 * @LastEditTime: 2020-10-10 17:54:12
 * @LastEditors: Cao_ming
 * @FilePath: \local_merchant_React\app\common\CheckboxTag\index.tsx
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { message, Tag } from 'hljd'
import styles from './style.module.less'

const { CheckableTag } = Tag

interface Props {
  options: { name: string; value: any }[]
  onChange: (value: any[]) => void
  style: React.CSSProperties
  value: any[],
  max?: number
}

interface State {
  values: any[]
}

export default class CheckboxTag extends Component<Props, State> {
  static propTypes = {
    options: PropTypes.array,
    onChange: PropTypes.func,
    style: PropTypes.object
  }

  static defaultProps = {
    options: [],
    onChange: () => {},
    style: {}
  }

  _onChange = (val, name, checked) => {
    let values = this.props.value ?? []
    if (checked) {
      values = [...values, {value: val,name: name}]
    } else {
      values = values.filter(f => f.value !== val)
    }

    if(this.props.max && values.length > this.props.max) {
      return message.error(`选择已超过最大限制`)
    }
    const { onChange } = this.props
    onChange && onChange(values)
  }

  render() {
    const { options, style, value = [] } = this.props
    return (
      <div className={styles.checkableTag}>
        {options.map(item => (
          <CheckableTag
            style={style}
            key={item.value}
            onChange={checked => this._onChange(item.value, item.name, checked)}
            checked={value.findIndex(f => f.value === item.value) !== -1}
          >
            {item.name}
          </CheckableTag>
        ))}
      </div>
    )
  }
}
